import { useState, useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { SafeArea } from 'capacitor-plugin-safe-area';

/**
 * Simple hook to get safe area insets
 * Returns safe area values for device notches, home indicators, etc.
 */
export const useSafeArea = () => {
  const [safeAreaInsets, setSafeAreaInsets] = useState({
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  });
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const initializeSafeArea = async () => {
      try {
        if (Capacitor.isNativePlatform()) {
          const result = await SafeArea.getSafeAreaInsets();
          setSafeAreaInsets(result.insets);

          // Listen for safe area changes (orientation, etc.)
          SafeArea.addListener('safeAreaChanged', (result) => {
            setSafeAreaInsets(result.insets);
          });
        }
        setIsInitialized(true);
      } catch (error) {
        console.warn('Safe area plugin not available:', error);
        setIsInitialized(true);
      }
    };

    initializeSafeArea();

    return () => {
      if (Capacitor.isNativePlatform()) {
        SafeArea.removeAllListeners();
      }
    };
  }, []);

  const hasSafeArea = safeAreaInsets.top > 0 || safeAreaInsets.bottom > 0 || 
                     safeAreaInsets.left > 0 || safeAreaInsets.right > 0;

  return { 
    safeAreaInsets, 
    isInitialized, 
    hasSafeArea 
  };
};
